import { NavLink } from 'react-router-dom';
import { cn } from '@saiens/shared/utils';
import { Home, Briefcase, FolderKanban, Calculator } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: '首頁' },
  { to: '/business', icon: Briefcase, label: '業務' },
  { to: '/accounting', icon: Calculator, label: '財會' },
  { to: '/project', icon: FolderKanban, label: '專案' },
];

export function BottomNav() {
  return (
    <nav className="glass fixed bottom-0 left-0 right-0 z-40 border-t border-white/30 safe-area-bottom">
      <div className="flex h-16 items-center justify-around">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-0.5 px-5 py-1.5',
                'transition-all duration-200',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={cn(
                    'flex h-8 items-center justify-center rounded-full px-4 transition-all duration-200',
                    isActive ? 'bg-primary/10' : 'bg-transparent'
                  )}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <span className={cn('text-[10px]', isActive ? 'font-semibold' : 'font-medium')}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
